import React from 'react'

const CaravanHeader =({caravan})=>
<>{caravan.country} - {caravan.county} - {caravan.town}</>


export default CaravanHeader;